// extracted by mini-css-extract-plugin
export default {"opener":"KebabButton_opener__JCTtS","glyph":"KebabButton_glyph__YvhzP","openerOpen":"KebabButton_openerOpen__b40kL"};